import api from '../utils/api';
export const getPatientsProfileInfo = (phoneNumberId) => {
  return api({
      url: '/api/patient/getPatientsProfileInfoByPhoneNumberId/' + phoneNumberId,
      method: 'GET'
  })
}



export const profileCommunicationCheckbox = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/patient/profilecommunicationcheckbox/${data.phoneNumberId}/${data.communication}`,
        method: "GET",
        data: data,
        ...options,
    });
}


export const getLocationsByPhoneNumberId = (phoneNumberId) => {
    return api({
        url: '/api/patient/getlocationsbyphonenumberid/' + phoneNumberId,
        method: 'GET'
    })
}


export const inactivatePhoneNumberById = (phoneNumberId) => {
    return api({
        url: '/api/patient/deletePhoneNumber/' + phoneNumberId,
        method: 'DELETE'
    })
}

export const activatePhoneNumberById = (phoneNumberId) => {
    return api({
        url: '/api/patient/activePhoneNumber/' + phoneNumberId,
        method: 'GET'
    })
}